import React from "react";
import "./about.css";
import ME from "../../assets/me_bg.png";
import Reveal from "../motion/Reveal";
import { motion, useReducedMotion } from "framer-motion";
import { fadeUp, scaleIn, stagger } from "../../motion";

const focus = [
  {
    n: "01",
    title: "Mobile products",
    text: "Cross-platform React Native apps with native-feel UI, store releases, and real-time features for teams on the floor.",
  },
  {
    n: "02",
    title: "Web platforms",
    text: "React, Next.js, and Angular apps — marketing sites, SaaS dashboards, and admin systems built to ship and scale.",
  },
  {
    n: "03",
    title: "Backend systems",
    text: "Node.js APIs, auth, databases, and workflows that keep web and mobile clients honest and fast.",
  },
  {
    n: "04",
    title: "Desktop tools",
    text: "Electron apps for internal operations — offline-friendly tooling packaged for Windows, macOS, and Linux.",
  },
];

const About = () => {
  const reduce = useReducedMotion();

  return (
    <section id="about" className="section about">
      <div className="container about__layout">
        <div className="about__main">
          <Reveal>
            <p className="section__label">
              <span>01</span> — About
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="section__title">
              Four years turning requirements into products people ship with.
            </h2>
          </Reveal>
          <Reveal className="about__copy" delay={0.1}>
            <p>
              Experienced React Native developer with 4+ years building and
              maintaining mobile, web, and desktop applications using React Native,
              React.js, Electron.js, and Python. I lead development teams, manage
              project lifecycles, collaborate with UI/UX and backend, run code
              reviews, and deliver scalable solutions with Agile/Scrum.
            </p>
            <p>
              At Solution Circle in Riyadh I&apos;ve shipped Timeloop, Eventy,
              Eventy OCR, Eventy Engage, and HR apps — from App Store releases to
              Firebase, geofencing, and Google Vision OCR on the show floor. Before
              that I built full-stack products at TechCreator and Valleyways Tech
              across Pakistan.
            </p>
            <p>
              I&apos;m fluent in English and Urdu, based in Riyadh on-site, and open
              to strong remote or relocation opportunities.
            </p>
          </Reveal>

          <div className="about__focus">
            <Reveal>
              <h3>What I do</h3>
            </Reveal>
            <motion.div
              className="about__grid"
              variants={stagger(0.08)}
              initial={reduce ? false : "hidden"}
              whileInView="show"
              viewport={{ once: true, amount: 0.2 }}
            >
              {focus.map((item) => (
                <motion.article key={item.n} variants={fadeUp}>
                  <span className="mono">{item.n}</span>
                  <h4>{item.title}</h4>
                  <p>{item.text}</p>
                </motion.article>
              ))}
            </motion.div>
          </div>
        </div>

        <Reveal className="about__aside" delay={0.12} variants={scaleIn}>
          <aside className="about__card">
            <div className="about__photo">
              <img src={ME} alt="Mustafa Zeb" />
            </div>
            <div className="about__card-body">
              <p className="mono">React Native & Project Management</p>
              <h3>Mustafa Zeb</h3>
              <p className="about__tz">AST · UTC+3</p>
              <dl>
                <div>
                  <dt>Based in</dt>
                  <dd>Riyadh, Saudi Arabia</dd>
                </div>
                <div>
                  <dt>Experience</dt>
                  <dd>4+ years</dd>
                </div>
                <div>
                  <dt>Languages</dt>
                  <dd>English, Urdu</dd>
                </div>
                <div>
                  <dt>Status</dt>
                  <dd>Open to work</dd>
                </div>
              </dl>
            </div>
          </aside>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
